import React, { Fragment } from 'react';
import {
    TextField, List,
    translate
} from 'react-admin';
import icons from '../res/icons'
import { Checkbox, ListItem, Toolbar, Grid, IconButton } from '@material-ui/core';
import {
    NodeActions,
} from 'ra-tree-ui-materialui';
import AppBar from '@material-ui/core/AppBar';
import { Datagrid } from 'react-admin';
import SaveIcon from '@material-ui/icons/Save';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import MyLocation from '@material-ui/icons/MyLocation';
import Menu from '@material-ui/core/Menu';
import Typography from '@material-ui/core/Typography';
import CopyFile from '../buttons/CopyFile';
import CutFile from '../buttons/CutFile';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TreeItem from './TreeItem';
import Paper from '@material-ui/core/Paper';
import PasteFile from '../buttons/PasteFile';
import UploadFile from '../buttons/UploadFile';
import CreateFolder from '../buttons/CreateFolder';
import RenameFile from '../buttons/RenameFile';
import LockFile from '../buttons/LockFile';
import DeleteFile from '../buttons/DeleteFile';
import DownloadFile from '../buttons/DownloadFile';
import { push as pushAction } from 'react-router-redux';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Drawer from '@material-ui/core/Drawer';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import { configAPI } from '../config'
import TextFieldUI from "@material-ui/core/TextField";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import CloseIcon from '@material-ui/icons/Close';
import EditorIcon from '@material-ui/icons/ModeEdit';
import Fullscreen from '@material-ui/icons/Fullscreen';
import IconConfbridge from '@material-ui/icons/OpenInNew';
import FullscreenExit from '@material-ui/icons/FullscreenExit';
import { resolveBrowserLocale } from 'react-admin';
import { messages } from '../res/messages';
import { Tooltip } from '@material-ui/core';
import jexcel from "jexcel";
import "../../node_modules/jexcel/dist/jexcel.css";
import HeJxlText from '../res/HeJxlText';
import axios from 'axios';


class CustomNodeCheckBox extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            notclicked: true,
        }
    }

    componentDidMount() {
        this.setState({ notclicked: true })
    }

    componentWillReceiveProps(prevProps) {
        if (sessionStorage.selectedFile.indexOf(this.props.record.what + '//..//') > -1) this.setState({ [this.props.record.id]: true })
        else this.setState({ [this.props.record.id]: false })
    }

    handleChange = name => event => {

        const { record } = this.props;
        var selectedFile;
        this.setState({ [name]: event.target.checked });
        if (sessionStorage.getItem("selectedFile") === null) selectedFile = ''
        else selectedFile = sessionStorage.getItem('selectedFile');

        if (event.target.checked) {
            selectedFile = record.what + '//..//' + selectedFile;
            sessionStorage.setItem('selectedFile', selectedFile);
        }
        else {
            selectedFile = selectedFile.replace(record.what + '//..//', '');
            sessionStorage.setItem('selectedFile', selectedFile);
        }
        this.setState({ multi: selectedFile.length > 1 });
    };

    handleCheckChange = name => event => {
        this.setState({ notclicked: false });
        var selectedFile;
        const { record } = this.props;
        this.setState({ [name]: event.target.checked });
        if (sessionStorage.getItem("selectedFile") === null) selectedFile = ''
        else selectedFile = sessionStorage.getItem('selectedFile');

        if (event.target.checked) {
            selectedFile = record.what + '//..//' + selectedFile;
            sessionStorage.setItem('selectedFile', selectedFile);
        }
        else {
            selectedFile = selectedFile.replace(record.what + '//..//', '');
            sessionStorage.setItem('selectedFile', selectedFile);
        }
        this.setState({ multi: selectedFile.length > 1 });
    };

    render() {
        const { data } = this.props;

        return (
            <NodeActions
                {...data}
                onClick={this.props.refreshActions}
            >
                <Checkbox
                    type='checkbox'
                    checked={sessionStorage.selectedFile.includes(this.props.record.what + '//..//') && this.props.checkall !== -1}//{(this.state[this.props.record.id])&&this.props.checkall!==-1}//||((this.props.checkall===true)&&this.state.notclicked) }
                    onChange={this.handleCheckChange(this.props.record.id)}
                    value={this.props.record.id}
                    onClick={(e) => { e.stopPropagation() }}
                />
            </NodeActions>
        );
    }
}


class SizeField extends React.Component {

    state = {};
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    formatBytes(a, b) { if (0 === a) return "0 Bytes"; var c = 1024, d = b || 2, e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], f = Math.floor(Math.log(a) / Math.log(c)); return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f] }

    render() {
        const { source, record } = this.props;
        try { var size = this.formatBytes(record[source], 2); }
        catch { size = '' }
        if (size === 'NaN undefined') size = '';
        return (<span>{size}</span>)
    }
}

class IvrList extends React.Component {

    constructor(props) {
        super(props);
        this.state = { height: 0 };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.refreshActions = this.refreshActions.bind(this)
        this.openIniEditor = this.openIniEditor.bind(this)
        this.wrapper = React.createRef();
        this.onToggle = this.onToggle.bind(this);

        this.state = {
            allDirs: {},
            anchorEl: null,
            openMenu: false,
            value: 0,
            width: 0,
            height: 0,
            openAudio: false,
            AudioPath: '',
            disabled: false,
            fullScreen: false,
            showActions: false,
            tabWidth: '100%',
            tabdisable: false,
            filePath: '',
            optionsXL: {
                text: HeJxlText,
                data: [[]],
                columns: [{ title: HeJxlText.id, width: 100 }, { title: HeJxlText.active, width: 100 },
                { title: HeJxlText.pname, width: 100 }, { title: HeJxlText.fname, width: 100 },
                { title: HeJxlText.email, width: 100 }, { title: HeJxlText.organization, width: 100 }],
                minDimensions: [6, 6]
            }
        };
    }

    componentWillMount() {
        if (sessionStorage.selectedFile === undefined) sessionStorage.setItem('selectedFile', '')

        if (sessionStorage.Messages !== null && sessionStorage.Messages !== '') {
            this.setState({ messageArray: JSON.parse(sessionStorage.getItem('Messages')) });
        }
        this.updateWindowDimensions();
        if (sessionStorage.getItem('AllDirs')) this.refreshDirs();

    }

    componentWillReceiveProps(prevProps) {
        if (sessionStorage.Messages !== null && sessionStorage.Messages !== '') {
            this.setState({ messageArray: JSON.parse(sessionStorage.getItem('Messages')) });
        }
    }

    componentDidMount() {

        var msgarr;
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);


        if (sessionStorage.Messages !== undefined && sessionStorage.Messages !== '') {
            msgarr = JSON.parse(sessionStorage.getItem('Messages'));
            this.setState({ messageArray: msgarr });

        }
        if (sessionStorage.Filter !== undefined && sessionStorage.Filter !== '') {
            var currentPath = JSON.parse(sessionStorage.Filter);
            this.setState({ currentPath: currentPath.path });
        }

        if (sessionStorage.getItem('AllDirs')) this.refreshDirs();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({ height: window.innerHeight * 0.85 });
    }

    table2CSV() {
        var data = this.JXL.getData();
        var cols = this.JXL.getHeaders();
        var csv = cols + '\n';
        data.forEach(row => {
            row.forEach(cell => {
                csv += cell + ',';
            });
            csv = csv.slice(0, -1) + '\n';
        });
        csv = csv.slice(0, -3)
        return csv;
    }

    updateTable(csv) {
        var csvRows = csv.split('\n');
        var csvCols = csvRows[0].split(',');
        var columns = [];
        var rows = [];
        csvCols.forEach((col, i) => {
            columns.push({ title: col, width: 100 })
        });

        csvRows.shift();
        csvRows.forEach(csvrow => {
            var row = csvrow.split(',');
            rows.push(row);
        });

        this.setState({
            optionsXL: {
                text: HeJxlText,
                data: rows,
                columns: columns,
                minDimensions: [columns.length, rows.length]
            }
        });
        this.JXL = jexcel(this.wrapper.current, this.state.optionsXL);
    }


    refreshDirs() {
        let data = sessionStorage.getItem('AllDirs').split(',');
        data.shift();
        const output = {};
        let current;

        for (const path of data) {
            current = output;
            for (const segment of path.split('/')) {
                if (segment !== '') {
                    if (!(segment in current)) {
                        current[segment] = {};
                    }
                    current = current[segment];
                }
            }
        }
        this.setState({ allDirs: output });
    }

    handleClickOpenAudio = () => {
        this.setState({ openAudio: true });
    };

    handleCloseMenuAudio = () => {
        this.setState({ openAudio: false });
        this.setState({ AudioPath: "" });
    };

    handleClickOpenEditor = () => {
        this.setState({ openEditor: true });
    };

    handleCloseMenuEditor = () => {
        this.setState({ openIniDrawer: false, tabWidth: '100%' });
        this.setState({ openEditor: false });
        this.setState({ fullScreen: false });
        this.setState({ iniContents: '' });
    };

    handleFullScreen = () => {
        this.setState({ fullScreen: !this.state.fullScreen });
    };

    handleIniContentChange = (e) => {
        this.setState({ iniContents: e.target.value });
    };

    handleChange = (event, value) => {
        this.setState({ value: value });
        if (sessionStorage.Messages !== null && sessionStorage.Messages !== '') {
            this.setState({ messageArray: JSON.parse(sessionStorage.getItem('Messages')) });
        }
        if (sessionStorage.Filter !== undefined && sessionStorage.Filter !== '') {
            var currentPath = JSON.parse(sessionStorage.Filter);
            this.setState({ currentPath: currentPath.path });
        }
    }

    handleCloseMenu = event => {
        (event !== undefined) && event.stopPropagation();
        this.setState({ anchorEl: false, rightClick: false, openMenu: false });
    };

    handleSubmit = () => {
        const { push } = this.props;
        var uploadContents = this.state.iniContents; //.replace(/(?:\r\n|\r|\n)/g, '%0A');
        var path = this.state.filePath.replace('ivr2:/', 'ivr/');
        var parts = path.split('/');
        var filename = parts[parts.length - 1];
        const blob = new Blob([uploadContents], { type: 'text/plain' });
        var data = new FormData();
        data.append('upload', blob, filename);
        data.append("token", sessionStorage.B.encodeDecode());
        data.append("path", path);
        axios.post(configAPI.api.prod + 'UploadFile', data).then(function (resp) {
            if (resp.data.responseStatus === 'OK') push('/IVR?filter=' + sessionStorage.Filter);
        });
    }

    refreshActions(e) {
        e.stopPropagation();
        var filter = sessionStorage.Filter;
        if (filter === undefined || filter === '') filter = '{"path":"ivr2:"}';
        this.setState({ showActions: !this.state.showActions });
        this.props.push('/IVR')
        this.props.push('/IVR?filter=' + filter)
    }

    openIniEditor(e) {
        e.stopPropagation();
        var path;
        this.setState({
            openIniDrawer: !this.state.openIniDrawer,
            tabWidth: (this.state.tabWidth === '70%') ? '100%' : '70%'
        });
        if (this.state.filePath) path = this.state.filePath;
        else if (sessionStorage.Filter) {
            var jsonPath = JSON.parse(sessionStorage.Filter);
            path = jsonPath.path;
            if (!path) path = 'ivr2:';
        }
        else path = 'ivr2:';
        if (path.indexOf('.') > -1) path = path.substr(0, path.lastIndexOf("/") + 1);

        const request = new Request(configAPI.api.prod + '/DownloadFile?&path=' + path + '/ext.ini&token=' + sessionStorage.B.encodeDecode(), {
            headers: new Headers({
                'Content-Type': 'text/json'
            }),
            method: 'GET'
        });

        fetch(request).then(data => data.text())
            .then(data => {
                this.updateIniContents(data, path)
            }, (error) => {
                if (error) {
                    this.updateIniContents('', path)
                }
            });

    }

    updateIniContents(iniContents, filePath) {
        this.setState({ iniContents: iniContents, filePath: filePath })
        sessionStorage.setItem('INI', iniContents);
    }

    updateCurrentNode() {
        if (this.props.history.location.search !== undefined) {
            var stringPath = this.props.history.location.search.replace('?filter=', '');
            var jsonPath = JSON.parse(stringPath);
            this.setState({ currentNode: jsonPath.path });
        }
    }

    handleCheckChange = name => event => {
        this.setState({ [name]: event.target.checked });
        if (name === 'checkall') {
            //workarround...
            var allfiles = sessionStorage.AllFiles.replace(/.$/, "//..//").replace(/,ivr/g, '//..//ivr');
            if (!this.state.checkall) sessionStorage.setItem('selectedFile', allfiles);
            else sessionStorage.setItem('selectedFile', '');
            this.refreshActions(event);
        }
    };

    onToggle(node, toggled) {
        const { cursor, data } = this.state;
        if (cursor) {
            this.setState(() => ({ cursor, active: false }));
        }
        node.active = true;
        if (node.children) {
            node.toggled = toggled;
        }
        this.setState(() => ({ cursor: node, data: Object.assign({}, data) }));
    }


    render() {
        const { translate, push, ...props } = this.props;
        const { value, disabled, messageArray } = this.state;
        var filterValues = JSON.parse(sessionStorage.getItem('Filter'));
        console.log(messageArray);
        if (filterValues !== null) if (filterValues.path !== undefined) var currentPath = filterValues.path;
        else currentPath = 'ivr2:';

        return (<>
            <AppBar position="static" color="default" style={{ width: `${this.state.tabWidth}` }} elevation={1}>
                <Toolbar>
                    <Typography variant="title" color="inherit">
                        {translate('resources.IVR.name')}
                    </Typography>
                </Toolbar>
            </AppBar>
            <Grid container spacing={24} sm={12}>
                <Grid item xs={4} sm={2} onClick={() => this.updateCurrentNode()}>
                    <br /><br />
                    <Paper style={{ height: `${this.state.height - 45}px`, width: `${this.state.tabWidth}`, overflow: 'scroll' }}>
                        <NavTree path={'/'} {...props} translate={translate} currentNode={this.state.currentNode} reaload={this.state.forceReload} />
                    </Paper>
                </Grid>
                <Grid item xs={20} sm={10} onClick={() => this.updateCurrentNode()}>
                    <Tabs value={value} onChange={this.handleChange}>
                        <Tab label={translate('trans.fileHandler')} />
                        <Tab label={translate('trans.messages')} disabled={this.state.tabdisable} />
                    </Tabs>
                    {(value === 0) && <Fragment>
                        <List  {...props}
                            actions={
                                <PostFilter tab = {'ivr'}
                                    openIniEditor={this.openIniEditor} updateIniContents={(iniContents, filePath) => this.updateIniContents(iniContents, filePath)}
                                    refreshActions={this.refreshActions} push={push} {...props}
                                    showActions={(this.state.showActions === -1) || ((sessionStorage.selectedFile) && (sessionStorage.selectedFile.length > 1))}
                                />}
                            uncheckAll={this.uncheckAll}
                            pagination={<PostPagination />}
                            bulkActionButtons={false}
                        >
                            <Datagrid {...props}
                                style={{ overflow: 'scroll' }}
                                onClick={() => this.setState({ rightClick: false })}
                                onContextMenu={(event) => { event.preventDefault(); this.setState({ anchorEl: event.target, rightClick: true, openMenu: true }) }}
                                rowClick={(id, basePath, record, context) =>
                                    {
                                    if (sessionStorage.getItem('AllDirs')) this.refreshDirs();
                                    if (context !== 'context') {
                                        if (record.fileType === 'EXT' || record.fileType === 'DIR' || record.fileType === 'INI') {
                                            this.setState({ currentNode: record.what });
                                            if (record.fileType === 'EXT' || record.fileType === 'INI') {
                                                var path = record.what;
                                                if (record.fileType === 'EXT') path += '/ext.ini';
                                                const request = new Request(configAPI.api.prod + '/DownloadFile?&path=' + path + '&token=' + sessionStorage.B.encodeDecode(), {
                                                    headers: new Headers({
                                                        'Content-Type': 'text/json'
                                                    }),
                                                    method: 'GET'
                                                });

                                                fetch(request).then(data => data.text())
                                                    .then(data => {
                                                        this.updateIniContents(data, path);
                                                        if (record.fileType === 'INI') this.setState({ openIniDrawer: true, tabWidth: '70%' });
                                                    }, (error) => {
                                                        if (error) {
                                                            this.updateIniContents('', path)
                                                        }
                                                    });
                                            }
                                            if (record.fileType !== 'INI') {
                                                this.setState({ checkall: false });
                                                sessionStorage.setItem('selectedFile', '');
                                                push('/IVR?filter={"path":"' + record.what + '","id":' + record.id + ',"type":"DIR"}');
                                            }
                                            this.setState({ messageArray: JSON.parse(sessionStorage.getItem('Messages')) });
                                        }
                                        else if (record.fileType !== 'AUDIO' && !(record.fileType === 'BIN' && /(.*).mp3/.test(record.name))) {
                                            if (record.fileType === 'YMGR') this.setState({ disabled: true });
                                            else this.setState({ disabled: false });
                                            this.setState({ openEditor: true });
                                            const request = new Request(configAPI.api.prod + '/DownloadFile?&path=' + record.what + '&token=' + sessionStorage.B.encodeDecode(), {
                                                headers: new Headers({
                                                    'Content-Type': 'text/json'
                                                }),
                                                method: 'GET'
                                            });

                                            fetch(request).then(data => data.text())
                                                .then(data => {
                                                    this.setState({ iniContents: data })
                                                    this.setState({ filePath: record.what })
                                                    this.setState({ fileType: record.fileType })
                                                });
                                        }
                                        else {
                                            this.setState({ openAudio: true });
                                            this.setState({ AudioPath: configAPI.api.prod + '/DownloadFile?&path=' + record.what + '&token=' + sessionStorage.B.encodeDecode() });
                                        }
                                    }
                                    else {
                                        this.setState({ menu: record })
                                    }
                                }}
                                >
                                <CustomNodeCheckBox label={
                                    <NodeActions>
                                        <Checkbox
                                            onChange={this.handleCheckChange('checkall')}
                                            checked={this.state.checkall}
                                        />
                                    </NodeActions>}
                                    record={props} refreshActions={this.refreshActions} checkall={this.state.checkall} />
                                <TreeItem label='' style={{ width: "20px" }} />
                                <TextField source="name" label={translate('resources.IVR.extname')}
                                    style={
                                        (sessionStorage.getItem("dir") !== null) ?
                                            ((sessionStorage.dir === 'rtl') ? { textAlign: 'right', fontWeight: 'bold' } : { textAlign: 'left', fontWeight: 'bold' }) :
                                            (resolveBrowserLocale() === 'he') ?
                                                ({ textAlign: 'right', fontWeight: 'bold' }) : ({ textAlign: 'left', fontWeight: 'bold' })
                                    }

                                    onContextMenu={(event) => { event.preventDefault(); this.setState({ anchorEl: event.target, openMenu: true }) }}
                                />
                                <TypeField source="fileType" label={translate('resources.IVR.fileType')} />
                                <TypeField source="extType" label={translate('resources.IVR.extType')} />
                                <TextField source="extTitle" label={translate('resources.IVR.extTitle')} />
                                <TextField source="what" label={translate('resources.IVR.what')} />
                                <TextField source="mtime" label={translate('resources.IVR.mtime')} />
                                <SizeField source="size" label={translate('resources.IVR.size')} />
                            </Datagrid>
                        </List>
                        <Menu
                            id="long-menu"
                            anchorEl={this.state.anchorEl}
                            open={this.state.openMenu}//{Boolean(this.state.anchorEl)}
                            onClose={this.handleCloseMenu}
                            PaperProps={{
                                style: {
                                    width: 50,
                                },
                            }}
                        >
                            {(sessionStorage.D.encodeDecode().indexOf('[' + currentPath + ']') > -1 || sessionStorage.C.encodeDecode() === 'ADMIN') && ([
                                (sessionStorage.C.encodeDecode() === 'ADMIN' && ((this.state.menu) && (this.state.menu.fileType === 'DIR' || this.state.menu.fileType === 'EXT'))) && (<LockFile handleCloseMenu={() => this.handleCloseMenu()} record={this.state.menu} />),
                                <RenameFile handleCloseMenu={() => this.handleCloseMenu()} record={this.state.menu} />,
                                (this.state.menu) && (this.state.menu.fileType === 'AUDIO') && (<UploadFile handleCloseMenu={() => this.handleCloseMenu()} record={this.state.menu} />),
                                <DeleteFile handleCloseMenu={() => this.handleCloseMenu()} record={this.state.menu} />,
                                <CutFile handleCloseMenu={() => this.handleCloseMenu()} record={this.state.menu} refreshActions={this.refreshActions} />,
                                <CopyFile handleCloseMenu={() => this.handleCloseMenu()} record={this.state.menu} refreshActions={this.refreshActions} />,
                                (this.state.menu) && (this.state.menu.fileType !== 'DIR' && this.state.menu.fileType !== 'EXT') && (<DownloadFile handleCloseMenu={() => this.handleCloseMenu()} record={this.state.menu} />)
                            ])
                            }
                        </Menu>
                    </Fragment   >}
                    {(value === 1 && messageArray !== null && messageArray.length >= 0) && <> <Paper component="nav" >
                        <List  {...props} pagination={<PostPagination />}
                            actions={
                                <PostFilter 
                                    openIniEditor={this.openIniEditor} updateIniContents={(iniContents, filePath) => this.updateIniContents(iniContents, filePath)}
                                    refreshActions={this.refreshActions} push={push} {...props}
                                    showActions={(this.state.showActions === -1) || ((sessionStorage.selectedFile) && (sessionStorage.selectedFile.length > 1))}
                                />}/></Paper><Paper style={{ height: window.innerHeight * 0.75,  overflow: 'scroll' }}>
                        {messageArray.map((message, index) => (
                                    <ListItem
                                        button
                                        onClick={() => {
                                            if (sessionStorage.AllFiles.indexOf('/' + message.name + ',') !== -1) {
                                                this.setState({ openAudio: true });
                                                this.setState({ AudioPath: configAPI.api.prod + '/DownloadFile?&path=' + this.state.currentPath + '/' + message.name + '&token=' + sessionStorage.B.encodeDecode() });
                                            }
                                        }}
                                    >
                                        <TreeItem record={message} label='' style={{ width: "20px" }} />
                                        {message.name}
                                        <UploadFile isMessage={true} handleCloseMenu={this.handleCloseMenu} msg={4} record={message} />
                                        {(sessionStorage.AllFiles.indexOf('/' + message.name + ',') !== -1) && (<><DownloadFile record={message} /><DeleteFile message={true} path={this.state.currentPath + '/' + message.name} /></>)}
                                        {messages[message.name]}
                                    </ListItem>
                                )
                        )}
                    </Paper></>}
                    <Dialog
                        open={this.state.openAudio}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={this.handleCloseMenuAudio}
                        aria-labelledby="alert-dialog-slide-title"
                        aria-describedby="alert-dialog-slide-description"
                        onBackdropClick={(e) => e.stopPropagation()}
                    >
                        <DialogTitle id="alert-dialog-slide-title">
                            {this.state.what}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-slide-description">
                                <audio controls key={this.state.AudioPath} autoPlay={true} controlsList="nodownload">
                                    <source src={this.state.AudioPath} type="audio/ogg" />
                                </audio>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleCloseMenuAudio} color="primary">
                                {translate('ra.action.close')}
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog {...props}
                        open={this.state.openEditor}
                        onClose={this.handleCloseMenuEditor}
                        scroll={this.state.scroll}
                        aria-labelledby="scroll-dialog-title"
                        fullWidth={true}
                        fullScreen={this.state.fullScreen}
                        disableBackdropClick={true}
                        disableEscapeKeyDown={true}
                        onBackdropClick={(e) => e.stopPropagation()}
                    >
                        <DialogTitle id="scroll-dialog-title">
                            {this.state.filePath}
                            <IconButton color="inherit" onClick={this.handleCloseMenuEditor} aria-label="Close" style={{ float: 'right' }}>
                                <CloseIcon />
                            </IconButton>
                            <IconButton color="inherit" onClick={this.handleFullScreen} aria-label="Close" style={{ float: 'right' }}>
                                {(this.state.fullScreen === false) ? <Fullscreen /> : <FullscreenExit />}
                            </IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                {(this.state.fileType !== 'HTML') && <TextFieldUI
                                    disabled={disabled}
                                    id="outlined-multiline-flexible"
                                    multiline
                                    fullWidth="true"
                                    fullHeigt="true"
                                    rows="25"
                                    value={this.state.iniContents}
                                    onChange={this.handleIniContentChange}
                                    margin="dense"
                                    helperText=""
                                    variant="outlined"
                                />}
                                {(this.state.fileType === 'HTML') && <div dangerouslySetInnerHTML={{ __html: this.state.iniContents }} />}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleCloseMenuEditor} color="primary">
                                {translate('ra.action.close')}
                            </Button>
                            <Button onClick={this.handleSubmit} color="primary">
                                {translate('ra.action.save')}
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Drawer
                        variant="temporary"
                        open={this.state.openIniDrawer}
                        anchor={(this.props.locale === 'he') ? ('left') : ('right')}
                    >
                        <div dir="ltr">
                            <br /><br /><br /><br />
                            <Typography color="primary" align="center" variant="title" style={{ background: '#E3F2FD' }}>{this.state.filePath}</Typography>
                            <Typography color="default" align="center" variant="subheading" style={{ background: '#E3F2FD' }}>
                                {translate('trans.forumLink')}
                            </Typography>
                            <Typography color="default" align="center" variant="subheading" style={{ background: '#E3F2FD' }}>
                                <a target="_blank" rel="noopener noreferrer" href="https://f2.freeivr.co.il" style={{ color: 'blue' }}> {translate('trans.here')}</a>
                            </Typography>
                            <br />
                            <IconButton onClick={this.handleCloseMenuEditor} color="primary" variant="outlined" style={{ float: 'right', marginBottom: '2px', marginLeft: '2px', marginRight: '2px' }}>
                                <CloseIcon />
                            </IconButton>
                            <IconButton onClick={this.handleSubmit} color="primary" variant="outlined" style={{ float: 'right', marginBottom: '2px' }}>
                                <SaveIcon />
                            </IconButton>
                            <TextFieldUI
                                style={{ marginLeft: '20px' }}
                                id="outlined-multiline-flexible"
                                // label={this.state.filePath}
                                multiline
                                fullWidth="true"
                                fullHeigt="true"
                                rows="40"
                                value={this.state.iniContents}
                                onChange={this.handleIniContentChange}
                                // className={classes.textField}
                                margin="normal"
                                helperText=""
                                variant="outlined"
                            />
                        </div>
                    </Drawer>
                </Grid>
            </Grid>
        </>
        )
    }
}

class NavTree extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            children: [],
            clicked: false,
            visibleChildren: false,
            mylocation: false
        }
    }

    componentDidMount() {
        this.setState({ children: [] });
        if (this.props.path === '/') this.loadX('/');
        this.setState({ path: this.props.path });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.currentNode != undefined) {
            var nPath = nextProps.currentNode.replace('ivr2:/', 'ivr2:');
            nPath = (nPath === 'ivr2:') ? '/' : nPath;
            var oPath = this.state.path.replace('ivr2:/', 'ivr2:');
            if (nPath === oPath) {
                this.setState({ mylocation: true });
                const request = new Request(configAPI.api.prod + '/GetIVR2Dir?&path=' + oPath + '&token=' + sessionStorage.B.encodeDecode(), {
                    headers: new Headers({
                        'Content-Type': 'text/json'
                    }),
                    method: 'GET'
                });
                return fetch(request)
                    .then(response => { return response.json(); })
                    .then(IVRDIR => {
                        this.setState({ children: IVRDIR.dirs });
                        sessionStorage.setItem('Messages', JSON.stringify(IVRDIR.messages));
                        sessionStorage.setItem('Filter', '{"path": "ivr2:' + IVRDIR.thisPath + '"}');
                    })
            }
            else if (nPath.indexOf(oPath + '/') > -1) {
                const request = new Request(configAPI.api.prod + '/GetIVR2Dir?&path=' + oPath + '&token=' + sessionStorage.B.encodeDecode(), {
                    headers: new Headers({
                        'Content-Type': 'text/json'
                    }),
                    method: 'GET'
                });
                return fetch(request)
                    .then(response => { return response.json(); })
                    .then(IVRDIR => {
                        this.setState({ children: IVRDIR.dirs, clicked: true, visibleChildren: true, mylocation: false });
                        sessionStorage.setItem('Messages', JSON.stringify(IVRDIR.messages));
                        sessionStorage.setItem('Filter', '{"path": "ivr2:' + IVRDIR.thisPath + '"}');
                    })
            }
            else this.setState({ mylocation: false })
        }
    }

    loadX = (path) => {

        this.props.history.push('/IVR?filter={"path":"' + path + '"}');

        if (this.state.clicked === false) {
            this.setState({ clicked: true, visibleChildren: true });
        }
        else {
            this.setState(prevState => ({
                visibleChildren: !prevState.visibleChildren
            }));
        }

        const request = new Request(configAPI.api.prod + '/GetIVR2Dir?&path=' + path + '&token=' + sessionStorage.B.encodeDecode(), {
            headers: new Headers({
                'Content-Type': 'text/json'
            }),
            method: 'GET'
        });
        return fetch(request)
            .then(response => { return response.json(); })
            .then(IVRDIR => {
                this.setState({ children: IVRDIR.dirs });
                sessionStorage.setItem('Messages', JSON.stringify(IVRDIR.messages));
                sessionStorage.setItem('Filter', '{"path": "ivr2:' + IVRDIR.thisPath + '"}');
            })

    }

    treeClick(path) {
        this.setState({ mylocation: true });
        if (path !== '/') this.loadX(path);
        else {
            this.props.history.push('/IVR?filter={"path":"/"}');
        }
    }

    render() {
        var path = this.props.path;
        var title = path.substring(path.lastIndexOf("/") + 1);
        var extTitle = this.props.extTitle;
        var icon;
        var extType = (this.props.extType !== undefined) ? this.props.extType : 'DIR';
        if (extType == undefined) icon = icons['DIR'];
        else icon = icons[extType];
        return (
            <div style={{ paddingRight: 10 }}>
                <Tooltip title={this.props.translate(`type.` + extType)}>
                    <Button style={{ textTransform: 'none' }} onClick={() => this.treeClick(path)}>
                        {(this.state.visibleChildren) ? (<ChevronLeft />) : (<ArrowDropDown />)}
                        {icon}
                        <Typography variant="caption">{title}</Typography>
                        {(extTitle !== undefined && extTitle !== '') && (<Typography variant="subheading">{'-"' + extTitle + '"'}</Typography>)}
                        {(this.state.mylocation) && (<MyLocation />)}
                    </Button>
                </Tooltip>
                {(this.state.visibleChildren) && (
                    <div>
                        {this.state.children.map(child => {
                            return (<NavTree translate={this.props.translate} path={child.what} extTitle={child.extTitle} extType={child.extType} history={this.props.history} currentNode={this.props.currentNode} />)
                        })}
                    </div>
                )}
            </div>
        )
    }
}


class PostFilter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            paste: false,
            showConfDialog: false
        }
    }

    nav = (pathArray, index) => {
        const { push } = this.props;
        var newPath = pathArray.slice(0, index + 1).join('/')
        sessionStorage.setItem('selectedFile', '')
        if (index > 0) var path = newPath;
        else path = "ivr2:";
        path += '/ext.ini';

        const request = new Request(configAPI.api.prod + '/DownloadFile?&path=' + path + '&token=' + sessionStorage.B.encodeDecode(), {
            headers: new Headers({
                'Content-Type': 'text/json'
            }),
            method: 'GET'
        });

        fetch(request).then(data => data.text())//.bind(this)
            .then(data => {
                this.setState({ iniContents: data })
                this.props.updateIniContents(data, path)
            }, (error) => {
                if (error) {
                    this.setState({ iniContents: '' })
                    this.props.updateIniContents('', path)
                }
            });

        if (newPath.lastIndexOf(".") !== newPath.length - 4 || newPath.lastIndexOf(".") !== -1) {
            this.setState({ checkall: false })
            if (index > 0) push('/IVR?filter={"path":"' + newPath + '"}');
            else { push('/IVR?filter={"path":"ivr2:"}') }
        }
    }

    render() {
        var pathArray;
        var { filterValues, translate } = this.props;
        if (filterValues == undefined) filterValues = JSON.parse(sessionStorage.getItem('Filter'));
        if (filterValues !== null) if (filterValues.path !== undefined) var currentPath = filterValues.path;
        else currentPath = 'ivr2:';
        if (filterValues.path !== undefined && filterValues.path !== 'ivr2:' && filterValues.path !== '/' && filterValues.path !== 'ivr2:/') pathArray = filterValues.path.replace(':', ':/').replace('//', '/').split('/');
        else pathArray = ['ivr2:'];
        return (
            <div style={{ width: '100%' }}>
                <br />
                <div>
                    {pathArray.map((path, index) => (
                        <Button style={{ textTransform: 'none' }} variant="contained" color="primary" onClick={() => this.nav(pathArray, index)}>
                            {(path === 'ivr2:') ? <span>{translate('trans.ROOT')}</span> : <span>{path}</span>}
                        </Button>
                    ))}
                    {(this.props.tab==='ivr')&&(<div style={{ float: 'left' }}>
                        {(sessionStorage.D.encodeDecode().indexOf('[' + currentPath + ']') > -1 || sessionStorage.C.encodeDecode() === 'ADMIN') && (<>
                            {(this.props.showActions) && (
                                <Fragment>
                                    <DeleteFile />
                                    <CutFile refreshActions={this.props.refreshActions} />
                                    <CopyFile refreshActions={this.props.refreshActions} />
                                </Fragment>)}
                            {(sessionStorage.copiedFile !== undefined && sessionStorage.copiedFile !== '') &&
                                (<PasteFile record={this.props.filterValues} />)}
                            {((sessionStorage.INI !== undefined) ? ((sessionStorage.INI.indexOf('type=confbridge') > -1) && (sessionStorage.INI.indexOf('conf_bridge_type=admin') < 0)) && (
                                <Tooltip title={translate(`trans.confbridge`)}>
                                    <IconButton onClick={(e) => {
                                        e.preventDefault();
                                        this.setState({ showConfDialog: true });
                                    }}><IconConfbridge />
                                    </IconButton>
                                </Tooltip>) : <></>)}
                            <UploadFile isMessage={this.props.isMessage} handleCloseMenu={this.handleCloseMenu} msg={4} record={this.props.filterValues} />
                            {(sessionStorage.C.encodeDecode() === 'ADMIN') && (<><CreateFolder handleCloseMenu={this.handleCloseMenu} record={this.props.filterValues} />
                                <IconButton color="default" onClick={this.props.openIniEditor}>
                                    <EditorIcon />
                                </IconButton>
                            </>)}
                        </>)}
                        <Dialog
                            open={this.state.showConfDialog}
                        >
                            <DialogTitle id="alert-dialog-title">{translate(`trans.confbridgeTitle`)}</DialogTitle>
                            <DialogActions>
                                <Button onClick={(e) => (sessionStorage.creditFile === 'Mivzak') ? window.open('https://www.call2all.co.il/ym/res/confbridgeMivzkMenual.pdf', '_blank') : window.open('https://f2.freeivr.co.il/post/36866', '_blank')} color="primary">
                                    {translate(`trans.confInfo`)}
                                </Button>
                                <Button onClick={(e) => window.open('https://confbridge.call2all.co.il/system-overview/real-time'
                                    , '_blank')} color="primary">
                                    {translate(`trans.confbridge`)}
                                </Button>
                                <Button onClick={(e) => this.setState({ showConfDialog: false })} color="primary">
                                    {translate(`trans.cancel`)}
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </div>)}
                </div>

            </div>
        )
    }
}

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

SizeField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.array.isRequired,
    push: PropTypes.func,
    showNotification: PropTypes.func,
};

const TypeField = translate(({ translate, source, record }) => <span>{translate('type.' + record[source])}</span>);

TypeField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

const PostPagination = props => <div />

PostFilter.propTypes = {
    push: PropTypes.func,
};
NavTree.propTypes = {
    push: PropTypes.func,
};
IvrList.propTypes = {
    push: PropTypes.func,
};

connect(null, {
    push: pushAction,
})(translate(PostFilter));
connect(null, {
    push: pushAction,
})(translate(NavTree));

connect(null, {
})(translate(TypeField));


export default connect(null, {
    push: pushAction,
})(translate(IvrList));
